declare global {
  interface Window {
    // https://cloud.google.com/recaptcha/docs/api-ref-checkbox-keys
    grecaptcha: {
      enterprise: {
        ready: (callback: () => void) => void;
        execute: (siteKey: string, action: { action: string }) => Promise<string>;
      };
    };

    // views/react/layout.jade
    viewConfig: {
      recaptcha: {
        enabledActions: string[];
        web: {
          siteKey: string;
        };
      };
    };
  }
}

async function recaptchaReady(): Promise<void> {
  return new Promise((resolve) => window.grecaptcha.enterprise.ready(resolve));
}

export async function recaptchaToken(action: string): Promise<string> {
  if (!window.viewConfig.recaptcha.enabledActions.includes(action)) {
    return '';
  }
  await recaptchaReady();
  return window.grecaptcha.enterprise.execute(window.viewConfig.recaptcha.web.siteKey, { action } );
}